export default __webpack_public_path__ + "static/media/bg@1x.38ab8a18.webp";